/**
 * Example:
 *
 * <ng-container *rerender='changingInput'>
 *    this content will be re-rendered everytime `changingInput` changes
 * </ng-container>
 */

import { ChangeDetectorRef, Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[rerender]',
})
export class RerenderDirective {
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private changeDetectorRef = inject(ChangeDetectorRef);

  @Input() set rerender(val: any) {
    this.viewContainer.clear();
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.changeDetectorRef.detectChanges();
  }
}
